// Security configuration constants and settings
import { GROUPS } from "../routes/constants.js";
import { PERMISSIONS } from "./permissions.js";
export const SECURITY_CONFIG = {
  // Token configuration
  TOKEN: {
    ACCESS_TOKEN_KEY: "juzoor_access_token",
    REFRESH_TOKEN_KEY: "juzoor_refresh_token",
    TOKEN_EXPIRY_KEY: "juzoor_token_expiry",
    DEFAULT_EXPIRY: 30 * 60 * 1000, // 30 minutes in milliseconds
  },

  // Session configuration
  SESSION: {
    TIMEOUT_WARNING: 5 * 60 * 1000, // 5 minutes warning before timeout
    IDLE_TIMEOUT: 15 * 60 * 1000, // 15 minutes idle timeout
    CHECK_INTERVAL: 30 * 1000, // Check every 30 seconds for responsive timeout
    REMEMBER_ME_TIMEOUT: 7 * 24 * 60 * 60 * 1000, // 7 days for remember me
  },

  // API endpoints
  ENDPOINTS: {
    LOGIN: "/auth/login",
    LOGOUT: "/auth/logout",
    REFRESH: "/auth/refresh",
    VERIFY: "/auth/verify",
    PROFILE: "/auth/profile",
  },

  // User roles and permissions (using shared constants)
  ROLES: {
    ...GROUPS,
    GUEST: "Guest", // keep consistent casing with GROUPS
  },

  // Permissions hierarchy
  ROLE_PERMISSIONS: {
    [GROUPS.ADMINS]: Object.values(PERMISSIONS),

    [GROUPS.PROJECT_MANAGERS]: [
      PERMISSIONS.CREATE_PROJECT,
      PERMISSIONS.EDIT_OWN_PROJECT,
      PERMISSIONS.EDIT_ASSIGNED_PROJECT,
      PERMISSIONS.VIEW_PROJECT,
      PERMISSIONS.CHANGE_PROJECT_STATUS,
      PERMISSIONS.ARCHIVE_PROJECT,
      PERMISSIONS.ASSIGN_PROJECT_MEMBERS,
      PERMISSIONS.UPLOAD_FILE,
      PERMISSIONS.DOWNLOAD_FILE,
      PERMISSIONS.DELETE_FILE,
      PERMISSIONS.CREATE_OUTPUT,
      PERMISSIONS.EDIT_OWN_OUTPUT,
      PERMISSIONS.EDIT_ASSIGNED_OUTPUT,
      PERMISSIONS.LINK_OUTPUT,
      PERMISSIONS.EDIT_SENSITIVE_FIELDS,
      PERMISSIONS.CREATE_ACTIVITY,
      PERMISSIONS.EDIT_OWN_ACTIVITY,
      PERMISSIONS.EDIT_ASSIGNED_ACTIVITY,
      PERMISSIONS.VIEW_ACTIVITY,
      PERMISSIONS.MANAGE_BUDGET,
      PERMISSIONS.CREATE_EXPENSE,
      PERMISSIONS.EDIT_EXPENSE,
      PERMISSIONS.DELETE_EXPENSE,
      PERMISSIONS.IMPORT_EXPENSE,
      PERMISSIONS.CREATE_INDICATOR,
      PERMISSIONS.EDIT_OWN_INDICATOR,
      PERMISSIONS.EDIT_ASSIGNED_INDICATOR,
      PERMISSIONS.VIEW_INDICATOR,
      PERMISSIONS.ARCHIVE_INDICATOR,
      PERMISSIONS.SUBMIT_DATA_POINT,
      PERMISSIONS.APPROVE_DATA_POINT,
      PERMISSIONS.VIEW_AUDIT_LOG,
    ],

    [GROUPS.STAFF]: [
      PERMISSIONS.EDIT_ASSIGNED_PROJECT,
      PERMISSIONS.VIEW_PROJECT,
      PERMISSIONS.EDIT_ASSIGNED_OUTPUT,
      PERMISSIONS.LINK_OUTPUT,
      PERMISSIONS.EDIT_SENSITIVE_FIELDS,
      PERMISSIONS.EDIT_ASSIGNED_ACTIVITY,
      PERMISSIONS.VIEW_ACTIVITY,
      PERMISSIONS.CREATE_EXPENSE,
      PERMISSIONS.EDIT_EXPENSE,
      PERMISSIONS.UPLOAD_FILE,
      PERMISSIONS.DOWNLOAD_FILE,
      PERMISSIONS.DELETE_FILE,
      PERMISSIONS.EDIT_ASSIGNED_INDICATOR,
      PERMISSIONS.VIEW_INDICATOR,
      PERMISSIONS.SUBMIT_DATA_POINT,
      PERMISSIONS.VIEW_AUDIT_LOG,
    ],

    [GROUPS.FINANCE_OFFICERS]: [
      PERMISSIONS.MANAGE_BUDGET,
      PERMISSIONS.CREATE_EXPENSE,
      PERMISSIONS.EDIT_EXPENSE,
      PERMISSIONS.DELETE_EXPENSE,
      PERMISSIONS.IMPORT_EXPENSE,
      PERMISSIONS.VIEW_PROJECT,
      PERMISSIONS.VIEW_OUTPUT,
      PERMISSIONS.VIEW_ACTIVITY,
      PERMISSIONS.VIEW_INDICATOR,
      PERMISSIONS.SUBMIT_DATA_POINT,
      PERMISSIONS.VIEW_AUDIT_LOG,
    ],
  },

  // Security headers
  HEADERS: {
    AUTHORIZATION: "Authorization",
    CONTENT_TYPE: "Content-Type",
    CSRF_TOKEN: "X-CSRF-Token",
  },

  // Storage options
  STORAGE: {
    USE_SESSION_STORAGE: false, // Use localStorage by default
    ENCRYPT_TOKENS: true,
  },
};

export default SECURITY_CONFIG;
/**
 * RBAC Configuration — Aligned with Product Spec (Phases 1–4)
 * Each user has exactly ONE role.
 * Permissions are feature-specific, not CRUD-generic.
 * Source: Unified RBAC Matrix — "role IN ('ADMIN','STAFF',...)"
 */
